import { render } from "./BusinessReservations.vue?vue&type=template&id=0d78a3e4"
import script from "./BusinessReservations.vue?vue&type=script&lang=js"
export * from "./BusinessReservations.vue?vue&type=script&lang=js"

import "./BusinessReservations.vue?vue&type=style&index=0&id=0d78a3e4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__